<template>
    <div class="btnBox">
        <button v-if="blank" :class="disabled ? 'btnBlank disabled' : 'btnBlank'" :disabled='disabled'><slot></slot></button>
        <button v-else :class="disabled ? 'btn disabled' : 'btn'" :disabled='disabled'><slot></slot></button>
    </div>
</template>
<script>
export default {
  name: "Tbutton",
  props: {
    disabled: Boolean,
    blank: Boolean,
  }
};
</script>
<style lang="scss" scoped>
.btnBox{
    min-width: 150px;
    min-height: 38px;
    display: block;
    font-size: 14px;
    .btn{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 20px;
        min-height: 38px;
        background: #7996F5;
        border-radius: 2px;
        outline: none;
        color: #fff;
        cursor: pointer;
    }
    .btn:hover{
        background: #8CA6FD;
    }
    .btn.disabled{
        background: #E5E5E5;
        cursor: not-allowed;
        color: #bcbcbc;
    }
    .btnBlank{
        width: 100%;
        height: 100%;
        min-height: 38px;
        background: #FFFFFF;
        border: 1px solid #7996F5;
        border-radius: 2px;
        outline: none;
        color: #7996F5;
        cursor: pointer;
    }
    .btnBlank:hover{
        color: #6985DF;
        border: 1px solid #6985DF;
    }
    .btnBlank.disabled{
        background: #F6F6F8;
        border: 1px solid #E5E5E5;
        color: #C3C3C3;
        cursor: not-allowed;
    }
}

</style>

